var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center",class:_vm.cssOptionalClass,attrs:{"id":"ReSpinner"}},[_c('b-spinner',{staticClass:"spinner",attrs:{"small":_vm.isSmall,"label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }